<template>
  <pf-card v-if="showIfEmpty || tickets.length > 0">
    <pf-card-header><pf-title h="3">{{ title }}</pf-title></pf-card-header>
    <pf-empty-state v-if="ticketsState.updating">
      <pf-empty-state-header :title="$t('Caricamento dei ticket')" heading-level="h4">
        <template #icon>
          <pf-empty-state-icon>
            <pf-spinner />
          </pf-empty-state-icon>
        </template>
      </pf-empty-state-header>
    </pf-empty-state>

    <pf-card-body v-else-if="tickets.length > 0">
      <pf-data-list compact>
        <pf-data-list-item v-for="t in tickets" :key="t.id">
          <pf-data-list-cell no-fill>
            <granted-link :to="{ name: 'ticket', params: { id: t.id } }">
              #{{ t.id }}
            </granted-link>
          </pf-data-list-cell>
          <pf-data-list-cell>
            {{ t.titolo }}
          </pf-data-list-cell>

          <pf-data-list-cell no-fill>
            {{ $datefromnow(t.data) }}
          </pf-data-list-cell>

          <pf-data-list-cell no-fill>
            <pf-label v-if="t.prodotto" color="grey">
              {{ $t('Prodotto: {0}', [t.prodotto]) }}
            </pf-label>
            <pf-label v-if="t.department" color="grey" class="pf-v6-u-mr-sm">
              {{ $t('Tipologia: {0}', [t.department]) }}
            </pf-label>
            <pf-label v-if="t.urgente" color="red">
              <template #icon>
                <triangle-exclamation-icon />
              </template>
              {{ $t('Urgente') }}
            </pf-label>
            <pf-label :color="t.stato == 'aperto' ? 'green' : 'grey'">
              {{ t.stato == 'aperto' ? $t('Aperto') : $t('Chiuso') }}
            </pf-label>
          </pf-data-list-cell>
          <pf-data-list-action>
            <granted-link :to="{ name: 'ticket', params: { id: t.id } }" type="primary" small>
              {{ $t('Visualizza') }}
            </granted-link>
          </pf-data-list-action>
        </pf-data-list-item>
      </pf-data-list>
    </pf-card-body>

    <pf-card-body v-else>
      <pf-empty-state variant="xs">
        <pf-empty-state-header :title="$t('Nessun ticket aperto')" heading-level="h4">
          <template #icon>
            <magnifying-glass-icon />
          </template>
        </pf-empty-state-header>
        <pf-empty-state-footer>
          <pf-empty-state-actions>
            <pf-button :to="{ name: 'ticket', params: { id: 'new' } }" variant="primary">{{ $t('Apri un nuovo ticket') }}</pf-button>
          </pf-empty-state-actions>
        </pf-empty-state-footer>
      </pf-empty-state>
    </pf-card-body>

    <pf-card-footer v-if="onlyOpen" class="pf-v6-u-text-align-end">
      <pf-button :to="{ name: 'tickets' }" variant="link" icon-position="end">
        <template #icon><arrow-right-icon /></template>
        {{ $t('Visualizza tutti i ticket') }}
      </pf-button>
    </pf-card-footer>
  </pf-card>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { asyncComputedList } from '@common/asyncComputed';
import { TicketResource } from '@/resources';
import GrantedLink from '@/components/granted-link.vue';
import TriangleExclamationIcon from '@vue-patternfly/icons/triangle-exclamation-icon';
import MagnifyingGlassIcon from '@vue-patternfly/icons/magnifying-glass-icon';
import ArrowRightIcon from '@vue-patternfly/icons/arrow-right-icon';

const { state: ticketsState, result: tickets } = asyncComputedList (() => new TicketResource({ onlyOpen: props.onlyOpen ? 1 : 0 }).get());

const props = withDefaults(defineProps<{
  title: string;
  showIfEmpty?: boolean;
  onlyOpen?: boolean;
}>(), {
  title: _t('Ultimi ticket aperti'),
});
</script>
